import React from "react";

const map = {
  draft: { label:"Draft", cls:"bg-slate-700/40 text-slate-300 border-slate-600" },
  generating: { label:"Generating", cls:"bg-cyan-500/10 text-cyan-300 border-cyan-500/30" },
  needs_review: { label:"Needs review", cls:"bg-amber-500/10 text-amber-300 border-amber-500/30" },
  ready: { label:"Ready", cls:"bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  final: { label:"Final", cls:"bg-blue-500/10 text-blue-300 border-blue-500/30" },
  archived: { label:"Archived", cls:"bg-slate-800 text-slate-500 border-slate-700" },
  active: { label:"Active", cls:"bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  complete: { label:"Complete", cls:"bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  missing: { label:"Missing", cls:"bg-red-500/10 text-red-300 border-red-500/30" },
};

export default function StatusBadge({ status }) {
  const s = map[status] || { label: status, cls: "bg-slate-800 text-slate-300 border-slate-700" };
  return <span className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full border ${s.cls}`} data-testid={`status-${status}`}>{s.label}</span>;
}
